import {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {commonLogDate2} from '../../common/app_common';
import {getApiSystemServiceLog, postApiSystemServiceRestart} from '../../common/fetch_api/api_common';

export const InfoModal = ({info, show, handleClose}) => {

    const [infoView, setInfoView] = useState({cpu: '', mem: '', disk: ''});

    useEffect(() => {

        if( !info ) return;

        let cpuUsage = `${parseFloat(info.data.cpuUsage).toFixed(1)} %`;
        let memUsage = `${parseFloat(info.data.memUsed).toFixed(2)} ${info.data.unit}`;
        let diskUsage = `${parseFloat(info.data.diskUsed).toFixed(2)} ${info.data.unit}`;

        setInfoView({cpu: cpuUsage, mem: memUsage, disk: diskUsage});

    }, [show, info]);

    const onClickDownload = () => {

        if( !info ) return;

        Promise.resolve( getApiSystemServiceLog(info.name) )
        .then( log => {
            let filePath = `${info.name}_${commonLogDate2()}.txt`;
            let element = document.createElement('a');
            element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(log));
            element.setAttribute('download', filePath);
            document.body.appendChild(element);
            element.click();
            element.remove();
        })
    }

    const onClickRestart = () => {
        
        if( !info ) return;

        Promise.resolve( postApiSystemServiceRestart(info.name) )
        .then( done => {
            console.log('postApiSystemServiceRestart', done);
        })
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Service Infomation</h6>
            </Modal.Header>
            <Modal.Body className='system-service-modal'>
                <div className="d-flex">
                    <div className="col-4 label-box">CPU Usage</div>
                    <div className="col-8">
                        <input className="form-control input-box" type="text" value={infoView.cpu} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-4 label-box">MEM Usage</div>
                    <div className="col-8">
                        <input className="form-control input-box" type="text" value={infoView.mem} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-4 label-box">DISK Usage</div>
                    <div className="col-8">
                        <input className="form-control input-box" type="text" value={infoView.disk} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-4 label-box">Log</div>
                    <div className="col-8">
                        <Button variant="primary" className="btn-sm text-white" onClick={onClickDownload}>Download</Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-4 label-box">Service</div>
                    <div className="col-8">
                        <Button variant="primary" className="btn-sm text-white" onClick={onClickRestart}>Restart</Button>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};